import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationsApiAdapter } from '../adapters/NotificationsApiAdapter';

export const useArchiveNotification = () => {
  const queryClient = useQueryClient();
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new NotificationsApiAdapter(httpClient);

  return useMutation({
    mutationFn: (notificationId: number) =>
      adapter.archiveNotification(notificationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
};
